export enum ReservationLimitInterval {
	DAILY = "daily",
	WEEKLY = "weekly",
	MONTHLY = "monthly"
}
